import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestHelper } from '@shared/helper/request.helper';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { APIConstant } from '@shared/constant/api.constant';
import { NavigationConstant } from '@shared/constant/navigation.constant';
import { MessageConstant } from '@shared/constant/message.constant';
import { paymentVaStorage } from '@shared/storage/payment-va.storage';

@Component({
  selector: 'app-inquiry-alfa',
  templateUrl: '../../inquiry.component.html'
})
export class InquiryAlfaComponent implements OnInit {

  companyCode = 20001097;
  hostname: any = environment.hostName;
  form: FormGroup;
  isLoading = false;
  isSubmitted = false;
  imagePath = 'devex/simulator/images/bank/alfamart.png';
  moduleName = 'Alfamart';
  storeId :any;
  productCode: any;

  constructor(
    private apiService: RequestHelper,
    private router: Router,
    private storage: paymentVaStorage
  ) {
    this.form = new FormBuilder().group({
      vaNumber: [null, Validators.required],
      companyCode: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.storage.imagePath = this.imagePath;
    this.storage.moduleName = this.moduleName;
  }

  submitInquiry() {
    this.isSubmitted = true;
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    this.storage.data.vaNumber = this.form.get('vaNumber').value;
    this.storage.data.companyCode = this.form.get('companyCode').value;

    this.apiService.post(environment.apiUrl + APIConstant.ALFA_INQUIRY,
      JSON.stringify(this.form.getRawValue())).subscribe((data) => {
        this.storage.inquiryResult = data;
        return this.router.navigate([NavigationConstant.ALFA_PAYMENT]);
      }, (err) => {
        this.isLoading = false;
        this.openDialog(MessageConstant.CANNOT_PROCESS);
      }
      );
  }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.ALFA_INQUIRY);
  }
}
